import { useEffect, useState, useMemo } from 'react';
import { UsersFetchAPI } from '../../api/Users';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import SmartpayModal from '../Modal/Modal';
import ModalRoles from './Roles/ModalRoles';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

import './user.css'


// import UsersPanel from './UsersPanel';

export default function Users() {
    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');

    const [userBranchoffices, setUserBranchs] = useState([]);
    const [selectedUserOption, setSelectedUserOption] = useState({
        name: '', email: '', phone: '', idCard: '', roles: [], user_code: '', branchoffices: [], user_id: ''
    });
    const [users, setUsers] = useState([]);
    const [authorizedUserRoles, setAuthorizedUserRoles] = useState([]);
    const [eventHandler, setEventHandler] = useState(0);
    const [formData, setFormData] = useState({});

    const [modalFields, setModalFields] = useState([
        { name: 'name', label: 'Nombre', type: 'text', placeholder: 'Ingrese nombre', required: true },
        { name: 'email', label: 'Correo', type: 'email', placeholder: 'Ingrese correo', required: true },
        { name: 'phone', label: 'Telefono', type: 'phone', placeholder: 'Ingrese telefono', required: true },
        { name: 'idCard', label: 'Cedula', type: 'text', placeholder: 'Ingrese la cedula', required: true },
        { name: 'pass', label: 'Contraseña', type: 'password', placeholder: 'Ingrese Contraseña', required: true },
        { name: 'passCheck', label: 'Confirmar contraseña', type: 'password', placeholder: 'Ingrese Contraseña', required: true },
        { name: 'role_id', label: 'Roles', type: 'checkbox', options: authorizedUserRoles, required: true },
        { name: 'branchoffice_Id', label: 'Sucursal', type: 'checkbox', options: userBranchoffices, required: true }
    ]);

    const [modalFieldsAsing, setModalFieldsAsing] = useState([
        { name: 'branchoffice_id', label: 'Sucursal', type: 'select', options: userBranchoffices, required: true }
    ]);

    const [modalFieldsAsingUser, setModalFieldsAsingUser] = useState([
        { name: 'role_id', label: 'Roles', type: 'select', options: authorizedUserRoles, required: true }
    ]);

    const [showNewUserModal, setShowNewUserModal] = useState(false);
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [showModalAsing, setShowModalAsing] = useState(false);
    const [showModalAsingModule, setShowModalAsingModule] = useState(false);
    const [showModalAsingUserRole, setShowModalAsingUserRole] = useState(false);
    const [businessRoles, setBusinessRoles] = useState([]);
    const [availableRoles, setAvailableRoles] = useState([]);

    /* ── NEW UI STATES ── */
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [delTarget, setDelTarget] = useState(null);
    const [toast, setToast] = useState(null);

    const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

    /* ── FILTERED & PAGINATED DATA ── */
    const filteredUsers = useMemo(() => {
        if (!searchTerm.trim()) return users;
        const q = searchTerm.toLowerCase();
        return users.filter(u =>
            (u.name || '').toLowerCase().includes(q) ||
            (u.email || '').toLowerCase().includes(q) ||
            (u.idCard || '').toLowerCase().includes(q) ||
            (u.user_code || '').toLowerCase().includes(q)
        );
    }, [users, searchTerm]);

    const totalPages = Math.max(1, Math.ceil(filteredUsers.length / rowsPerPage));
    const paginatedUsers = filteredUsers.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    const pgNums = () => {
        const ps = [], mx = 5;
        let st = Math.max(1, currentPage - ~~(mx / 2)), en = Math.min(totalPages, st + mx - 1);
        if (en - st < mx - 1) st = Math.max(1, en - mx + 1);
        if (st > 1) { ps.push(1); if (st > 2) ps.push("…"); }
        for (let i = st; i <= en; i++) ps.push(i);
        if (en < totalPages) { if (en < totalPages - 1) ps.push("…"); ps.push(totalPages); }
        return ps;
    };

    /* ── ALL ORIGINAL FUNCTIONS (UNCHANGED) ── */
    const showNewUserModalHandler = () => {
        setShowNewUserModal(true);
        let lastModalFields = modalFields;
        lastModalFields[6].type = 'checkbox';
        lastModalFields[6].options = authorizedUserRoles.map(element => ({ name: element.label, id: element.value }));
        lastModalFields[7].type = 'checkbox';
        lastModalFields[7].options = user.branchoffices.map(element => ({ name: element.branchoffice_name, id: element.branchoffice_id }));
        setModalFields(lastModalFields);
        getBusinessUserRoles();
        getUsersByBranchofficeAndRoles();
        setFormData({ name: "", email: "", phone: "", idCard: "", pass: '', passCheck: '' });
    };

    const getUsersByBranchofficeAndRoles = async () => {
        try {
            let branchoffices = user.branchoffices.map(element => element.branchoffice_id);
            const response = await UsersFetchAPI.getUsersByBranchofficesAndRole(branchoffices, availableRoles, token);
            setUsers(response.data.users);
        } catch (err) { console.log(err); }
    };

    const getRolesByUser = async (user_role_id) => {
        try {
            const response = await UsersFetchAPI.getRoleByUser(user_role_id, token);
            let roles = response.data.data.map(element => ({ value: element.id, label: element.name }));
            setAvailableRoles(response.data.data.map(element => element.id));
            //We set the roles
            setAuthorizedUserRoles(roles);
            setEventHandler(1);
        } catch (err) { console.log(err); setAuthorizedUserRoles([]); }
    };

    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({ ...prevData, [fieldName]: value }));
    };

    const getUserDetails = async (user_id, modalType) => {
        try {
            const response = await UsersFetchAPI.getUserById(user_id, localStorage.getItem('x-access-token'));
            let userRoles = response.data.user.role.map(element => { return { id: element.role_id, name: element.name } });
            setSelectedUserOption({
                name: response.data.user.name, email: response.data.user.email, phone: response.data.data.phone,
                idCard: response.data.user.idCard, roles: response.data.user.role, branchoffices: response.data.user.branchoffices, user_id: response.data.user.id
            });
            if (modalType !== 'asingModal') {
                let lastModalFields = [
                    { name: 'name', label: 'Nombre', type: 'text', placeholder: 'Ingrese nombre' },
                    { name: 'email', label: 'Correo', type: 'email', placeholder: 'Ingrese correo' },
                    { name: 'phone', label: 'Telefono', type: 'phone', placeholder: 'Ingrese telefono' },
                    { name: 'idCard', label: 'Cedula', type: 'text', placeholder: 'Ingrese la cedula' },
                    { name: 'pass', label: 'Contraseña', type: 'text', placeholder: 'Ingrese Contraseña' },
                    { name: 'passCheck', label: 'Confirmar contraseña', type: 'text', placeholder: 'Ingrese Contraseña' },
                    { name: 'role_id', label: 'Roles', type: 'checkbox', options: userRoles },
                    { name: 'branchoffice_Id', label: 'Sucursal', type: 'checkbox', options: userBranchoffices }
                ];
                lastModalFields[7].options = response.data.user.branchoffices;
                if (modalType === 'editModal') {
                    lastModalFields[7].type = "list"; lastModalFields[6].type = "list";
                    setFormData({ name: response.data.user.name, email: response.data.user.email, phone: response.data.data.phone, idCard: response.data.user.idCard, role_id: response.data.user.role_id, pass: '', passCheck: '' });
                } else {
                    setFormData({ name: "", email: "", phone: "", idCard: "", pass: '', passCheck: '' });
                }
                setModalFields(lastModalFields);
            }
        } catch (err) { console.log(err); }
    };

    const removeUserRole = async (user_id, role_id) => {
        try {
            await UsersFetchAPI.removeUserRole(user_id, role_id, localStorage.getItem('x-access-token'));
            SuccessAlert('Rol eliminado');
            await getUserDetails(user_id, "editModal");
        } catch (err) { console.log(err); ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const asingUserRole = async (e) => {
        e.preventDefault();
        try {
            await UsersFetchAPI.asingUserRole(selectedUserOption.user_id, formData.role_id, localStorage.getItem('x-access-token'));
            SuccessAlert('Rol asignado');
            setShowModalAsingUserRole(false);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const newUser = async (e) => {
        e.preventDefault();
        try {
            formData.business_id = user.business.id;
            await UsersFetchAPI.registerUser(formData, localStorage.getItem('x-access-token'));
            SuccessAlert('Subscripcion realizada');
            setEventHandler(1);
            setShowNewUserModal(false);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const editUser = async (e) => {
        e.preventDefault();
        try {
            await UsersFetchAPI.updateUser(selectedUserOption.user_id, formData, localStorage.getItem('x-access-token'));
            SuccessAlert('Usuario actualizado');
            getUsersByBranchofficeAndRoles();
            await getUserDetails(selectedUserOption.user_id, "editModal");
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const removeUserBranch = async (user_id, branchoffice_id) => {
        try {
            await UsersFetchAPI.removeUserFromBranchoffice(user_id, branchoffice_id, localStorage.getItem('x-access-token'));
            SuccessAlert('Usuario eliminado de la sucursal');
            await getUserDetails(user_id, "editModal");
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const asingUserBranch = async (e) => {
        e.preventDefault();
        try {
            await UsersFetchAPI.asingUserToBranchoffice(selectedUserOption.user_id, formData.branchoffice_id, localStorage.getItem('x-access-token'));
            SuccessAlert('Usuario asignado a la sucursal');
            setShowModalAsing(false);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const removeUser = async (user_id) => {
        try {
            await UsersFetchAPI.removeUser(user_id, localStorage.getItem('x-access-token'));
            SuccessAlert('Usuario eliminado');
            getUsersByBranchofficeAndRoles();
            setDelTarget(null);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error', 'error'); }
    };

    const toggleUserStatus = async (content) => {
        const isEnabled = content.enabled !== 0;
        const newStatus = isEnabled ? 0 : 1;
        try {
            await UsersFetchAPI.toggleUserStatus(content.user_id, newStatus, token);
            setUsers(prev => prev.map(u => u.user_id === content.user_id ? { ...u, enabled: newStatus } : u));
            showToast(newStatus === 1 ? `Usuario "${content.name}" habilitado` : `Usuario "${content.name}" deshabilitado`);
        } catch (err) {
            console.log(err);
            ErrorAlert(err?.response?.data?.error || 'No se pudo actualizar el estado del usuario', 'Error', 'error');
        }
    };

    const getBusinessUserRoles = async () => {
        try {
            const response = await UsersFetchAPI.getUserRolesByBusiness(user.business.id, token);
            setBusinessRoles(response.data.data);
        } catch (err) { setBusinessRoles([]); }
    };

    useEffect(() => {
        setUserBranchs(user.branchoffices);
        getRolesByUser(user.role);
        setEventHandler(0);
    }, []);

    useEffect(() => {
        let lastModalFields = modalFields;
        let lastAsingModalFields = modalFieldsAsing;
        let lastAsingModalFieldsUser = modalFieldsAsingUser;
        lastModalFields[6].options = authorizedUserRoles;
        lastAsingModalFields[0].options = user.branchoffices.map((branch) => ({ value: branch.branchoffice_id, label: branch.branchoffice_name }));
        lastAsingModalFields[0].options.unshift({ value: 0, label: 'Seleccione una sucursal' });
        lastModalFields[7].options = user.branchoffices.map(element => ({ name: element.branchoffice_name, id: element.branchoffice_id }));
        //We set the user roles on the user asing modal 
        lastAsingModalFieldsUser[0].options = authorizedUserRoles.map((role) => ({
            value: role.value, label: role.label
        }));
        lastAsingModalFieldsUser[0].options.unshift({ value: 0, label: 'Seleccione un rol' });
        //We set the modal fields
        setModalFields(lastModalFields);
        setModalFieldsAsing(lastAsingModalFields);
        setModalFieldsAsingUser(lastAsingModalFieldsUser);
        getBusinessUserRoles();
        getUsersByBranchofficeAndRoles();
        setEventHandler(0);
    }, [eventHandler]);

    /* ═══ ICONS (inline SVGs) ═══ */
    const Icons = {
        Users: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
        Search: ({ s = 13 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>,
        Plus: ({ s = 14 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
        Edit: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" /></svg>,
        Trash: ({ s = 14 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
        Settings: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.32 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>,
        ChevLeft: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6" /></svg>,
        ChevRight: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6" /></svg>,
        Store: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
        Shield: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
        Mail: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22 6 12 13 2 6" /></svg>,
        Power: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0" /><line x1="12" y1="2" x2="12" y2="12" /></svg>,
    };

    const defaultImg = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="%239090A0" stroke-width="1.5" stroke-linecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>');

    return (
        <AppShell route="users">
            <MainContent>           

                {/* ══ HIDDEN ORIGINAL MODALS (still functional, just visually hidden behind overlay) ══ */}
                <SmartpayModal buttonModal={false} setShowModal={setShowNewUserModal} showModal={showNewUserModal} modal_size={"lg"} modal_header_text={"Nuevo usuario"} modal_body={modalFields} submit={newUser} handleFieldChange={handleFieldChange} initialFormValues={formData} formType={"addForm"} setEventHandler={setEventHandler} />
                <SmartpayModal buttonModal={false} modal_size={"lg"} modal_header_text={"Editar usuario"} modal_body={modalFields} submit={editUser} setShowModal={setShowEditUserModal} showModal={showEditUserModal} handleFieldChange={handleFieldChange} initialFormValues={formData} formType={"editForm"} removeUserBranch={removeUserBranch} removeUserRole={removeUserRole} selectedUserOption={selectedUserOption} />
                <SmartpayModal buttonModal={false} modal_size={"xs"} modal_header_text={"Asignar sucursal"} modal_body={modalFieldsAsing} submit={asingUserBranch} setShowModal={setShowModalAsing} showModal={showModalAsing} initialFormValues={formData} handleFieldChange={handleFieldChange} formType={"addForm"} selectedUserOption={selectedUserOption} />
                <SmartpayModal buttonModal={false} modal_size={"xs"} modal_header_text={"Asignar rol"} modal_body={modalFieldsAsingUser} submit={asingUserRole} setShowModal={setShowModalAsingUserRole} showModal={showModalAsingUserRole} initialFormValues={formData} handleFieldChange={handleFieldChange} formType={"addForm"} selectedUserOption={selectedUserOption} />
                <ModalRoles showModal={showModalAsingModule} setShowModal={setShowModalAsingModule} setEventHandler={setEventHandler} eventHandler={eventHandler} user={user} businessRoles={businessRoles} token={token} />

                <div>
                    <div >
                        {/* ══ TOP BAR ══ */}
                        <div className="us-top">
                            <div>
                                <div className="us-top__title"><Icons.Users /> Usuarios</div>
                                <div className="us-top__sub">Gestión y creación de usuarios</div>
                            </div>
                            <div className="us-top__right">
                                <button className="us-btn-s" onClick={() => setShowModalAsingModule(true)}>
                                    <Icons.Settings /> Roles
                                </button>
                                <button className="us-btn-p" onClick={showNewUserModalHandler}>
                                    <Icons.Plus /> Nuevo usuario
                                </button>
                            </div>
                        </div>

                        {/* ══ SECTION ══ */}
                        <div className="us-section">
                            <div className="us-section__head">
                                <div className="us-section__title">{filteredUsers.length} usuario{filteredUsers.length !== 1 ? 's' : ''}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <span style={{ fontSize: 12, color: '#9090A0' }}>Filas</span>
                                    <div className="us-rpp-group">
                                        {[5, 10, 20].map(n => (
                                            <button key={n} className={`us-rpp-btn ${rowsPerPage === n ? 'us-rpp-btn--active' : ''}`}
                                                onClick={() => { setRowsPerPage(n); setCurrentPage(1); }}>{n}</button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Search */}
                            <div className="us-filter-row">
                                <div className="us-search-wrap">
                                    <div className="us-search-icon"><Icons.Search /></div>
                                    <input className="us-search-input" placeholder="Buscar por nombre, correo, cédula, código..."
                                        value={searchTerm} onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
                                </div>
                            </div>

                            {/* ── TABLE (desktop) ── */}
                            <div className="us-table-wrap">
                                <table className="us-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 50 }}></th>
                                            <th>Nombre</th>
                                            <th>Código</th>
                                            <th>Cédula</th>
                                            <th>Correo</th>
                                            <th>Estado</th>
                                            <th style={{ textAlign: 'right' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedUsers.length === 0 ? (
                                            <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#9090A0' }}>Sin resultados</td></tr>
                                        ) : paginatedUsers.map((content, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <img className="us-avatar-img" src={content.img || defaultImg} alt={content.name}
                                                        onError={e => { e.target.src = defaultImg; }} />
                                                </td>
                                                <td>
                                                    <div style={{ fontWeight: 600 }}>{content.name}</div>
                                                    <div style={{ fontSize: 11, color: '#9090A0' }}>{content.email}</div>
                                                </td>
                                                <td><span className="us-code">{content.user_code}</span></td>
                                                <td style={{ fontSize: 13 }}>{content.idCard}</td>
                                                <td><span style={{ fontSize: 12, color: '#6B6B80' }}><Icons.Mail /> {content.email}</span></td>
                                                <td>
                                                    <span className={`us-status-badge ${content.enabled !== 0 ? 'us-status-badge--on' : 'us-status-badge--off'}`}>
                                                        <span className="us-status-dot" />
                                                        {content.enabled !== 0 ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <div className="us-actions">
                                                        <button className="us-action-btn us-action-btn--edit" title="Editar"
                                                            onClick={() => { setShowEditUserModal(true); getUserDetails(content.user_id, "editModal"); }}>
                                                            <Icons.Edit />
                                                        </button>
                                                        <button className="us-action-btn us-action-btn--assign" title="Asignar sucursal"
                                                            onClick={() => { setShowModalAsing(true); getUserDetails(content.user_id, 'asingModal'); }}>
                                                            <Icons.Store />
                                                        </button>
                                                        <button className="us-action-btn us-action-btn--assign" title="Asignar rol"
                                                            onClick={() => { setShowModalAsingUserRole(true); getUserDetails(content.user_id, 'asingModal'); }}>
                                                            <Icons.Shield />
                                                        </button>
                                                        <button className={`us-action-btn us-action-btn--status ${content.enabled !== 0 ? 'is-on' : 'is-off'}`}
                                                            title={content.enabled !== 0 ? 'Deshabilitar usuario' : 'Habilitar usuario'}
                                                            onClick={() => toggleUserStatus(content)}>
                                                            <Icons.Power />
                                                        </button>
                                                        <button className="us-action-btn us-action-btn--del" title="Eliminar"
                                                            onClick={() => setDelTarget(content)}>
                                                            <Icons.Trash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* ── MOBILE CARDS ── */}
                            <div className="us-cards-wrap">
                                {paginatedUsers.map((content, index) => (
                                    <div key={index} className="us-card">
                                        <div className="us-card__head">
                                            <img className="us-avatar-img" src={content.img || defaultImg} alt={content.name}
                                                onError={e => { e.target.src = defaultImg; }} />
                                            <div className="us-card__info">
                                                <div className="us-card__name">{content.name}</div>
                                                <div className="us-card__email">{content.email}</div>
                                            </div>
                                            <span className="us-code">{content.user_code}</span>
                                        </div>
                                        <div className="us-card__body">
                                            <div style={{ fontSize: 12, color: '#6B6B80', marginBottom: 8 }}>Cédula: {content.idCard}</div>
                                            <span className={`us-status-badge ${content.enabled !== 0 ? 'us-status-badge--on' : 'us-status-badge--off'}`}>
                                                <span className="us-status-dot" />
                                                {content.enabled !== 0 ? 'Activo' : 'Inactivo'}
                                            </span>
                                        </div>
                                        <div className="us-card__foot">
                                            <div className="us-actions">
                                                <button className="us-action-btn us-action-btn--edit" onClick={() => { setShowEditUserModal(true); getUserDetails(content.user_id, "editModal"); }}><Icons.Edit /></button>
                                                <button className="us-action-btn us-action-btn--assign" onClick={() => { setShowModalAsing(true); getUserDetails(content.user_id, 'asingModal'); }}><Icons.Store /></button>
                                                <button className="us-action-btn us-action-btn--assign" onClick={() => { setShowModalAsingUserRole(true); getUserDetails(content.user_id, 'asingModal'); }}><Icons.Shield /></button>
                                                <button className={`us-action-btn us-action-btn--status ${content.enabled !== 0 ? 'is-on' : 'is-off'}`}
                                                    title={content.enabled !== 0 ? 'Deshabilitar usuario' : 'Habilitar usuario'}
                                                    onClick={() => toggleUserStatus(content)}><Icons.Power /></button>
                                                <button className="us-action-btn us-action-btn--del" onClick={() => setDelTarget(content)}><Icons.Trash /></button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* ── PAGINATION ── */}
                            {filteredUsers.length > rowsPerPage && (
                                <div className="us-pag">
                                    <div className="us-pag__info">Mostrando <b>{(currentPage - 1) * rowsPerPage + 1}</b>–<b>{Math.min(currentPage * rowsPerPage, filteredUsers.length)}</b> de <b>{filteredUsers.length}</b></div>
                                    <div className="us-pag__pages">
                                        <button className="us-page-btn" disabled={currentPage <= 1} onClick={() => setCurrentPage(p => p - 1)}><Icons.ChevLeft /></button>
                                        {pgNums().map((p, i) => p === "…" ? <span key={`e${i}`} className="us-pag__ell">…</span> : <button key={p} className={`us-page-btn ${currentPage === p ? 'us-page-btn--active' : ''}`} onClick={() => setCurrentPage(p)}>{p}</button>)}
                                        <button className="us-page-btn" disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)}><Icons.ChevRight /></button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ══ DELETE CONFIRMATION ══ */}
                    {delTarget && (
                        <div className="us-overlay" onClick={() => setDelTarget(null)}>
                            <div className="us-confirm" onClick={e => e.stopPropagation()}>
                                <div className="us-confirm__body">
                                    <div className="us-confirm__icon"><Icons.Trash s={24} /></div>
                                    <div className="us-confirm__title">¿Eliminar este usuario?</div>
                                    <div className="us-confirm__desc">Esta acción no se puede deshacer.</div>
                                    <div className="us-confirm__name">{delTarget.name}</div>
                                </div>
                                <div className="us-confirm__footer">
                                    <button className="us-btn-s" style={{ flex: 1, justifyContent: 'center' }} onClick={() => setDelTarget(null)}>Cancelar</button>
                                    <button className="us-btn-danger" onClick={() => removeUser(delTarget.user_id)}>
                                        <Icons.Trash s={14} /> Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Toast */}
                    {toast && <div className="us-toast">{toast}</div>}
                </div>
            </MainContent>
        </AppShell>
    );
}

